module.exports = __webpack_public_path__ + "img/binoculars.81381a9b.svg";